export const scrollToDuplicatedComp = idx => {
  const comp = document.getElementById(`comp-${idx}`)
  comp && comp.scrollIntoView({ behavior: 'smooth' })
}
